import axios from "axios";
import { getLoggedUser } from "explorer/reducers/users";
import { loginReduced } from "explorer/reducers/auth";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  DISTRO_PARAM,
  PRICING_PARAM,
  TOKEN,
} from "shared/constants/StorageConsts";
import {
  autenticado,
  hasHeroPending,
  hasQuizPending,
} from "shared/helpers/auth-functions";
import { useTranslation } from "react-i18next";
import {
  getLoggedUserArtist,
  getUserDistroToken,
} from "explorer/reducers/artistas";
import { getStrmClassVideos } from "explorer/reducers/strm-class";
import { getMonitoredData } from "explorer/reducers/monitored-data";
import { getUserSubscription } from "explorer/reducers/subscription";

const AlternativeAutentication: React.FC<any> = (props) => {
  const { location } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { loggedUser, loading } = useSelector((state: any) => state.users);

  useEffect(() => {
    const urlSearch = new URLSearchParams(location.search);
    const getAuthToken = async (code: string) => {
      try {
        const response: any = await axios.post(
          `${process.env.REACT_APP_HOST_ENDPOINT}auth/oauth2/token`,
          {
            code,
            redirectUri: encodeURIComponent(window.location.origin),
          }
        );

        localStorage.setItem(TOKEN, response.data);
        dispatch(getLoggedUser());
        dispatch(getLoggedUserArtist());
        dispatch(getStrmClassVideos());
        dispatch(getMonitoredData());
        dispatch(getUserDistroToken());
        dispatch(getUserSubscription());
      } catch {}
    };

    const handleRequests = async () => {
      dispatch(loginReduced());
      const distroFlow = sessionStorage.getItem(DISTRO_PARAM) === "true";
      const pricingFlow = sessionStorage.getItem(PRICING_PARAM) === "true";
      if (hasQuizPending()) {
        history.push("/quiz");
        return;
      }
      if (hasHeroPending()) {
        history.push("/strm-hero");
        return;
      }

      const returnURL = sessionStorage.getItem("returnURL");
      sessionStorage.removeItem("returnURL");

      if (distroFlow) {
        history.push("/distribua");
        return;
      }
      if (pricingFlow) {
        history.push("/pricing");
        return;
      }
      if (returnURL) {
        history.push(returnURL);
        return;
      }
      history.push("/", { login: true });
    };

    if (loading && !autenticado()) getAuthToken(urlSearch.get("code") || "");
    if (!loading) handleRequests();
  }, [loading, location, loggedUser, dispatch, history, i18n]);

  return <div style={{ height: "100vh", backgroundColor: "#26272c" }} />;
};

export default AlternativeAutentication;
